import { IModularFamily } from '../../../redux/slices/ModularEnrolmentSlice/types';
import { IAlacarte } from '../../../redux/slices/PolicyListSlice/types';

export interface IFamilyUpgradeDiff {
    prev: string;
    prevOrg: string;
    new: string;
}

export enum IPlanDeletionDiffMode {
    EDIT = 'EDIT',
    DEL = 'DELETE'
}
export interface IPlanDeletionDiff {
    plan: IAlacarte;
    deletableDependents: IModularFamily[];
    newPremium: string;
    prevPremium: string;
    downgradedStructure: string;
    mode: IPlanDeletionDiffMode;
}

export interface IUseModularAddOns {
    isVisible: boolean;
    setIsVisible: (visible: boolean) => void;
    isCompleteModalVisible: boolean;
    isDeleting: boolean;
    isDeletionModalVisible: boolean;
    isUpgrading: boolean;
    isDowngrading: boolean;
    selectedAddOns: string[];
    deletionPlan: IPlanDeletionDiff | undefined;
    famDefUpgrade: IFamilyUpgradeDiff | undefined;
    readMorePlan: IAlacarte | undefined;
    addOns: IAlacarte[];
    onModalClose: () => void;
    handleSelect: (id: string) => void;
    handleUpdate: (prev: string, curr: string) => void;
    handleRemove: (id: string) => void;
    handleReadMore: (plan: IAlacarte) => void;
    closeReadMoreModal: () => void;
    handleCloseCompletionModal: () => void;
    handleCloseDeletionModal: () => void;
    confirmRemoveDependents: () => void;
}

export interface IUpgradedFamilyStructureResponse {
    originalStructure: string;
    upgradedStructure: string;
}
